export const baseURL = "/api";
export const timeout = 10000;
export const headers = {}


